import React, { useEffect } from "react";
import Header from "./Header";
import PlainLayout from "./PlainLayout";
import SideMenu from "./SideMenu";
import classnames from "classnames";
import { useUIData } from "../hooks/useUIData";
import { useOutsideClick } from "../hooks";
import { RouteKeys } from '../../containers/routes/route-keys';
import { useLocation } from 'react-router';

const AppLayout: React.FunctionComponent<{
  hideSideMenu?: boolean;
  className?: string;
  showOpenHideMenu?: boolean;
}> = (props) => {
  const ui = useUIData();
  // const [openMenu, setOpenMenu] = React.useState(!props.showOpenHideMenu);
  const [openMenu, setOpenMenu] = React.useState(true);
  const sidemenuRef = React.useRef<HTMLDivElement>(null);
  const headerMenuRef = React.useRef<HTMLDivElement>(null);
  const location = useLocation();

  const handleClick = (e: any) => {
    if (headerMenuRef?.current === null) {
      if (sidemenuRef?.current && !sidemenuRef?.current.contains(e.target)) {
        setOpenMenu(false);
        ui.changeSideMenuExpandedStatus(false);
      }
    } else {
      if (
        sidemenuRef?.current &&
        !sidemenuRef?.current.contains(e.target) &&
        headerMenuRef?.current &&
        !headerMenuRef?.current.contains(e.target)
      ) {
        setOpenMenu(false);
        ui.changeSideMenuExpandedStatus(false);
      }
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
  useEffect(() => {
    if (location.pathname === RouteKeys.Home){
      ui.changeSideMenuExpandedStatus(true);
    }
  }, []);

  return (
    <PlainLayout overMenu={props.showOpenHideMenu}>
      <Header
        headerMenuRef={headerMenuRef}
        onMenuOpen={() => {
          ui.changeSideMenuExpandedStatus(!ui.sideMenuExpanded);
        }}
        // onMenuOpen={() => {
        //   setOpenMenu(!openMenu);
        //   ui.changeSideMenuExpandedStatus(true);
        // }}
        showOpenHideMenu={props.showOpenHideMenu}
      ></Header>
      <div className="content-wrapper">
        <div className="row no-gutters flex-nowrap">
          {/* {!props.hideSideMenu && openMenu && (*/}
          <div
            className={`col-auto sidemenu bg-white border-right ${
              props.className ? props.className : ""
            }`}
          >
            <SideMenu
              showOpenHideMenu={props.showOpenHideMenu}
              onMenuClose={() => {
                setOpenMenu(false);
              }}
              sidemenuRef={sidemenuRef}
            />
          </div>
          {/* )} */}
          <div
            className={classnames({
              col: true,
              "right-content-section":
                !props.hideSideMenu && !props.showOpenHideMenu,
            })}
          >
            <div className="right-content-inner d-flex flex-column">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </PlainLayout>
  );
};

export default AppLayout;
